import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';
import { DynamicModalContext } from '../../../init/dynamicModals';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";
import { FaPlus } from "react-icons/fa";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const InvoiceAccount = (props) => {

    const { journalVoucher, setJournalVoucher } = props;

    const { api, userData, settingData, auxAccountData, warehouseData, selectedYear } = useContext(DataContext);

    const { openAddCustomerModal } = useContext(DynamicModalContext);

    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);

    const minDate = `${selectedYear?.label}-01-01`;
    const maxDate = `${selectedYear?.label}-12-31`;

    const { showModal, toggleModal, table, title, refreshTable, size, footer, idRow, type, validated } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);

    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    const customerAccountData = auxAccountData.filter(account => account.type === 'Customer');

    // Account Options
    const accountOptions = customerAccountData?.map(item => ({
        value: item.id,
        label: (item?.parent?.accountId ? item?.parent?.accountId + '.' : '') + item.accountId + ' ' + item.english,
    }));

    // Load and filter account options
    const loadAccountOptions = (inputValue, callback) => {
        const filteredOptions = inputValue ? accountOptions.filter(option =>
            option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];
        callback(filteredOptions);
    };


    // warehouse Options
    const warehouseOptions = warehouseData?.map(item => ({
        value: item.id,
        label: item.name,
    }))


    // Generic handler for input changes
    const handleInputChange = (e, type) => {
        let { name, value } = e.target;
        setJournalVoucher((prev) => ({
            ...prev,
            [name]: value,
        }));
    };




    // handle select change
    const handleSelectChange = (selectedOption, name) => {
        setJournalVoucher((prev) => ({
            ...prev,
            [name]: selectedOption?.value,
        }));
    };



    return (


        <div>
            <Row className="mb-3">

                <Col>
                    <Form.Label>Account</Form.Label>
                    <FaPlus onClick={() => openAddCustomerModal()} style={{ marginLeft: '20px', marginBottom: '3px', cursor: 'pointer' }} />
                    <AsyncSelect
                        cacheOptions
                        isClearable={true}
                        loadOptions={loadAccountOptions}
                        defaultOptions={[]}
                        onChange={(e) => handleSelectChange(e, 'accountId')}
                        value={accountOptions?.find(option => option.value === journalVoucher.accountId) || []}
                        noOptionsMessage={() => 'type to view'}
                    />
                </Col>

                <Col>
                    <Form.Label>Date<span style={{ color: 'red' }}>*</span></Form.Label>

                    <Form.Control type="date" name='date'
                        min={minDate} max={maxDate}
                        value={journalVoucher.date}
                        onChange={(e) => handleInputChange(e, 'text')}
                    />
                </Col>
            </Row>




            {/* Supplier */}
            <Row className="mb-3">

                {/* Reference */}
                <Col>
                    <Form.Label>Reference#</Form.Label>
                    <Form.Control type="text" name="refNumber"
                        onChange={(e) => handleInputChange(e, 'text')}
                        value={journalVoucher.refNumber} />
                </Col>


                <Col>
                    <Form.Label>warehouse<span style={{ color: 'red' }}>*</span></Form.Label>
                    <Select
                        options={warehouseOptions}
                        isSearchable={true}
                        placeholder="Select"
                        onChange={(e) => handleSelectChange(e, 'warehouseId')}
                        value={warehouseOptions?.find(option => option.value === journalVoucher.warehouseId) || []}
                        required
                    />
                </Col>

            </Row>


        </div>


    )
}


export default InvoiceAccount;